import { render, staticRenderFns } from "./KoreanLsports.vue?vue&type=template&id=31b07975&scoped=true"
import script from "./KoreanLsports.vue?vue&type=script&lang=js"
export * from "./KoreanLsports.vue?vue&type=script&lang=js"
import style0 from "./KoreanLsports.vue?vue&type=style&index=0&id=31b07975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b07975",
  null
  
)

export default component.exports